import { useQuery } from '@tanstack/react-query';
import { apiSgb } from '@stb/utils/axios-instance';

const ENDPOINT = '/simcard-monitoring/total-expire';

export function useQueryCountSimcardMonitoring({ limitPage } = { limitPage: 0 }) {
  const { isLoading, data, refetch } = useQuery({
    queryKey: [ENDPOINT],
    queryFn: () => fetchSimcardMonitoringList(),
    retry: 3,
  });

  return { data, isLoading, refetch };
}

async function fetchSimcardMonitoringList() {
  try {
    const res = await apiSgb.get(ENDPOINT);
    const data = res.data.data;
    return {
      data,
    };
  } catch (error) {
    throw error ?? 'Terjadi kesalahan saat mengambil data count simcard monitoring.';
  }
}
